import { Component, ViewEncapsulation } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-not-activated-error',
  templateUrl: './not-activated.component.html',
  styleUrls: ['./not-activated.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotActivatedErrorComponent {
  companyLogo = `./assets/icons/headerlogo-${environment.tenant.trim().toLowerCase()}.png`;
}
